export const FETCH_PROMO_GIFT_START = 'FETCH_PROMO_GIFT_START';
export const FETCH_PROMO_GIFT_SUCCESS = 'FETCH_PROMO_GIFT_SUCCESS';
export const FETCH_PROMO_GIFT_FAILURE = 'FETCH_PROMO_GIFT_FAILURE';
